import css from './PageButtonsBar.module.scss';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

export default function PageButtonsBar({ buttons }) {
  const { ref, inView } = useInView();

  return (
    <>
      <div className={css['bar']} ref={ref}>
        <div className={css['buttons']}>{buttons}</div>
      </div>

        <motion.div
          animate={{
            opacity: inView ? 0 : 1,
            visibility: inView ? 'hidden' : 'visible',
          }}
          initial={false}
          transition={{ ease: 'easeInOut', duration: 0.15 }}
          className={css['buttons-hover']}
        >
          {buttons}
        </motion.div>
    </>
  );
}
